module.exports = __webpack_public_path__ + "img/mail-icon.bf9b9da6.svg";